import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.65, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, lead, align = "left" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand">{eyebrow}</p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
        {title}
      </h2>
    </Reveal>
    {lead && (
      <Reveal delay={0.16}>
        <p className="mt-4 text-base leading-relaxed text-slate-600">{lead}</p>
      </Reveal>
    )}
  </div>
);

export const PageHeader = ({ eyebrow, title, lead }) => (
  <section className="relative overflow-hidden bg-navy text-white">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 opacity-[0.14]"
      style={{
        backgroundImage:
          "linear-gradient(rgba(255,255,255,0.35) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.35) 1px, transparent 1px)",
        backgroundSize: "72px 72px",
      }}
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-brand opacity-20 blur-3xl"
    />
    <div className="relative mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20 lg:py-24">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: EASE }}
        className="text-xs font-semibold uppercase tracking-[0.22em] text-brand"
      >
        {eyebrow}
      </motion.p>
      <div className="mt-4 overflow-hidden">
        <motion.h1
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.7, delay: 0.08, ease: EASE }}
          className="font-display text-4xl font-bold tracking-tight sm:text-5xl"
        >
          {title}
        </motion.h1>
      </div>
      {lead && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, delay: 0.22, ease: EASE }}
          className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg"
        >
          {lead}
        </motion.p>
      )}
    </div>
  </section>
);